import React, { Component } from 'react';

class SelectForm extends Component {

    handleChange = (e) => {
        let value = e.target.value
        let {name} = this.props
        this.props.onChange(name, value)
    }

    render() {
        let {value, data} = this.props
        let dataOpts = data.map((opt, idx) => {
            return <option value={opt} key={idx}>{opt}</option>
        })
        return (
            <div className="form-group">
                <select name="" value={value} className="form-control form-control-mix" onChange={this.handleChange.bind(this)}>
                    {dataOpts}
                </select>
            </div>
        );
    }
}

export default SelectForm;